import { Col, Row } from '@design-system/components/grid/grid';
import { faDumbbell, faPhotoFilm } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { workoutVM } from '@client/new/pages/workout/WorkoutEdit';

export const AutoplayedActions = ({ id }: { id: string }) => {
  const workout = workoutVM.useValue();

  return (
    <Col gap="m">
      <Row gap="m">
        <Typography variant="body" size="large" fontWeight="bold">
          Add:
        </Typography>
      </Row>
      <Row gap="m">
        <Button
          variant="outlined"
          leftIcon={faPhotoFilm}
          onClick={() =>
            workout.dispatch('openLibrary', { parentId: id, action: 'add' })
          }
          className="max-w-[250px]"
        >
          From Library
        </Button>
        <Button
          variant="outlined"
          leftIcon={faDumbbell}
          onClick={() => workout.dispatch('addSubExercise', { parentId: id })}
          className="max-w-[150px]"
        >
          Exercise
        </Button>
      </Row>
    </Col>
  );
};
